import React from 'react';
import LogoMarca from '../../images/new-logo2-cmtech.png';

const LogoSmall = props => (
    <div>
        <img src={props.src && props.src.length > 0 ? props.src : LogoMarca} title="Logomarca" style={{width: "170px"}} />
    </div>
);

export default LogoSmall;